import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .container {
    padding-left: 100px;
    padding-right: 100px;
  }
  .header-component {
    .desktop {
      background-color: ${theme.white};
    }
  }

  .layout-component {
    background-color: ${theme.white};
  }

  .footer-component {
    background-color: ${theme.black};
  }

  .banner-container {
    padding-bottom: 70px;
  }

  .installation-container {
    .container {
      padding: 0 115px 80px;
    }
  }

  .usp-container {
    padding-bottom: 80px;
  }

  .success-container {
    padding-bottom: 80px;
  }

  .step-container {
    padding-bottom: 80px;
  }

  .promotion-container {
    padding-bottom: 80px;
  }

  .review-container {
    background-color: ${theme.white};
    position: relative;
    padding-top: 10px;
    padding-bottom: 80px;
    margin-bottom: 120px;

    .container {
      position: relative;
      z-index: 2;
    }

    .bg-1 {
      position: absolute;
      background-color: #f8f9fa;
      transform: translateY(-20px) skew(0deg, -3deg);
      width: 100%;
      z-index: 2;
      height: 100%;
      top: -10px;
    }

    .bg-2 {
      position: absolute;
      background-color: #e9ecef;
      transform: translateY(20px) skew(0deg, 4deg);
      width: 100%;
      z-index: 1;
      height: 85%;
    }
  }

  .faq-container,
  .cta-container {
    background-color: ${theme.white};
  }

  @media (max-width: ${breakpoint.lg}) {
    .container {
      padding-left: 50px;
      padding-right: 50px;
    }
    .banner-container {
      padding-bottom: 35px;
      display: block;
    }

    .installation-container {
      .container {
        padding: 0 50px 80px;
      }
    }

    .usp-container {
      padding: 0 0 35px 0;
    }

    .step-container {
      padding: 0 0 35px 0;
    }

    .promotion-container {
      padding: 0 0 35px 0;
    }

    .review-container {
      padding-bottom: 70px;
      margin-bottom: 80px;
    }

    .success-container {
      padding: 0 0 80px 0;
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .container {
      padding-left: 30px;
      padding-right: 30px;
    }
    .banner-container {
    }

    .installation-container {
      .container {
        padding: 0 30px 40px;
      }
    }

    .usp-container {
    }

    .step-container {
    }

    .promotion-container {
    }

    .review-container {
      padding-top: 20px;
      padding-bottom: 60px;
      .bg {
        display: none;
      }
    }

    .success-container {
    }
  }
`
